/**
 * @generated SignedSource<<ae07c393101b1469dc010ac96c12100b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateInvoiceInput = {
  customerAccountIdentifier: string;
  customerOrderNotes?: string | null | undefined;
  invoiceDate?: any | null | undefined;
  invoiceTitle?: string | null | undefined;
  language?: string | null | undefined;
  lineItems?: ReadonlyArray<InvoiceLineItemInput | null | undefined> | null | undefined;
  paymentMethodIdentifier?: string | null | undefined;
  purchaseOrderReference?: string | null | undefined;
  timeOfPerformanceEnd?: any | null | undefined;
  timeOfPerformanceStart?: any | null | undefined;
};
export type InvoiceLineItemInput = {
  description: string;
  price?: number | null | undefined;
  quantity?: number | null | undefined;
  taxRatePercentage?: number | null | undefined;
  unitLabel?: string | null | undefined;
};
export type CreateInvoiceDialogMutation$variables = {
  input: CreateInvoiceInput;
};
export type CreateInvoiceDialogMutation$data = {
  readonly createInvoice: {
    readonly id: string;
  };
};
export type CreateInvoiceDialogMutation = {
  response: CreateInvoiceDialogMutation$data;
  variables: CreateInvoiceDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Invoice",
    "kind": "LinkedField",
    "name": "createInvoice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateInvoiceDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateInvoiceDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e6bbf6226d32a70e1eca6b5554ae6942",
    "id": null,
    "metadata": {},
    "name": "CreateInvoiceDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateInvoiceDialogMutation(\n  $input: CreateInvoiceInput!\n) {\n  createInvoice(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "07e1bb7e03cacf83ec0c6e9e40554535";

export default node;
